import { JSONValue } from '@/utils/types';

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';

export const FEATURE_FLAGS = {
	GDPR_OPT_OUT_BY_DEFAULT_FLAG: 'gdpr-opt-out-by-default',
};

export type FeatureFlags = Record<string, JSONValue>;
